// Third-party Library
import React, { useState } from "react"
import { Row, Radio, Typography } from "antd"

// Components
import CalendarLayout from "./CalendarLayout"
import TableReport from "../../TableReport"
import { parseDate } from "../../../../../services/util/time"

// import { getLatestDataPerDate, buildDefaultEntry } from "./handlers"

const { Text } = Typography

const MainLayout = ({ handleSelectDate, dataSource, selectedDate, ...tableProps }) => {

    const [ viewMode, setViewMode ] = useState('Month')

    return (
        <>
            <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>

                <Text style={{ fontSize: 13, color: "#6b7280" }}>
                    Selected Period:{" "}
                    <span style={{ color: "#1d78c8", fontWeight: 500 }}>
                        {parseDate(tableProps.startTime)} –{" "}
                        {parseDate(tableProps.endTime)}
                    </span>
                </Text>

                <Radio.Group value={viewMode} buttonStyle="solid" onChange={(e) => setViewMode(e.target.value)}>
                    {
                        ["Today", "Month", "List"].map((opt) => (
                            <Radio.Button
                                key={opt}
                                value={opt}
                                style={{
                                    background: viewMode === opt ? "#1a1a2e" : "#ffffff",
                                    color: viewMode === opt ? "#ffffff" : "#000000",
                                    borderColor: "#d9d9d9",
                                    fontWeight: viewMode === opt ? 500 : 400,
                                    transition: "all 0.2s",
                                }}
                            >
                                {opt}
                            </Radio.Button>
                        ))
                    }
                </Radio.Group>
            </Row>

            {
                viewMode === 'List' ?
                    <TableReport {...tableProps} dataReport={Object.values(dataSource).filter(d => d.status !== 'WORKING')}/>
                    :
                    <CalendarLayout handleSelectDate={handleSelectDate} selectedDate={selectedDate} dataSource={dataSource} {...tableProps}/>
            }
        </>
    )
}

export default React.memo(MainLayout)